import React from 'react';
import { Container, Typography, List, ListItem, Link, Box } from '@mui/material';

function OtherInfo() {
    return (
        <Container>
            {/* Funding Opportunities for Students */}
            <Box mb={4}>
                <Typography variant="h4" gutterBottom>
                    Funding Opportunities for Students 
                </Typography>
                <List>
                    <ListItem sx={{ padding: 0, marginBottom: '4px' }}>
                        <Typography variant="body2">
                            Teaching Assistance -{' '}
                            <Link href="https://u-aizu.ac.jp/curriculum/internal/student/sata.html" target="_blank" rel="noopener noreferrer">
                                JA
                            </Link>,{' '}
                            <Link href="https://u-aizu.ac.jp/en/curriculum/internal/student/sata.html" target="_blank" rel="noopener noreferrer">
                                EN
                            </Link>
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ padding: 0, marginBottom: '4px' }}>
                        <Typography variant="body2">
                            Research Assistance for Doctor Students (University Funding) -{' '}
                            <Link href="https://u-aizu.ac.jp/curriculum/internal/student/researchassistant.html" target="_blank" rel="noopener noreferrer">
                                JA
                            </Link>,{' '}
                            <Link href="https://u-aizu.ac.jp/en/curriculum/internal/student/researchassistant.html" target="_blank" rel="noopener noreferrer">
                                EN
                            </Link>
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ padding: 0, marginBottom: '4px' }}>
                        <Typography variant="body2">
                            Research Assistance for Other Students (Lab. Research Funding) -{' '}
                            <Link href="https://web-int.u-aizu.ac.jp/official/faculty/pd/fapd03_j.html" target="_blank" rel="noopener noreferrer">
                                JA
                            </Link>{' '}
                            (様式７－２),{' '}
                            <Link href="https://web-int.u-aizu.ac.jp/official/faculty/pd/fapd03_e.html" target="_blank" rel="noopener noreferrer">
                                EN
                            </Link>{' '}
                            (Form 7-2)
                        </Typography>
                    </ListItem>
                </List>
            </Box>

            {/* Other Info */}
            <Box mb={4}>
                <Typography variant="h4" gutterBottom>
                    Other Info (internal access only)
                </Typography>
                <List>
                    <ListItem sx={{ padding: 0, marginBottom: '4px' }}>
                        <Typography variant="body2">
                            Definition of Major Journal / Conference -{' '}
                            <Link href="https://web-int.u-aizu.ac.jp//official/students/sad/stsa23_e.html" target="_blank" rel="noopener noreferrer">
                                Link 
                            </Link>
                        </Typography>
                    </ListItem>                    
                    <ListItem sx={{ padding: 0, marginBottom: '4px' }}>
                        <Typography variant="body2">
                            How to use Plagiarism Checker -{' '}
                            <Link href="https://web-int.u-aizu.ac.jp/official/faculty/pd/file/Notification_PLAGIARISM_CHECKER.pdf" target="_blank" rel="noopener noreferrer">
                                Link to document
                            </Link>
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ padding: 0, marginBottom: '4px' }}>
                        <Typography variant="body2">
                            Application Forms (Misc.) -{' '}
                            <Link href="https://web-int.u-aizu.ac.jp/official/students/sad/stsa39.html" target="_blank" rel="noopener noreferrer">
                                Link
                            </Link>
                        </Typography>
                    </ListItem>
                </List>
            </Box>
        </Container>
    );
}

export default OtherInfo;
